import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ClerkProvider } from '@clerk/clerk-react';
import PublicHeader from './components/PublicHeader';
import Footer from './components/Footer';

// Marketing pages
import FeaturesPage from './pages/FeaturesPage';
import HowItWorksPage from './pages/HowItWorksPage';
import PricingPage from './pages/PricingPage';
import CheckoutPage from './pages/CheckoutPage';
import LandingPage from './pages/LandingPage';
import DownloadPage from './pages/DownloadPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfUsePage from './pages/TermsOfUsePage';
import ManageAccountPage from './pages/ManageAccountPage';
import ContactPage from './pages/ContactPage';
import AlexaOAuthPage from './pages/AlexaOAuthPage';
import AppRedirectPage from './pages/AppRedirectPage';
import AcceptInvitationPage from './pages/AcceptInvitationPage';
import JoinOrganizationPage from './pages/JoinOrganizationPage';
import PromoRedirectPage from './pages/PromoRedirectPage';

// Clerk publishable key from environment
const CLERK_PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || 'pk_live_Y2xlcmsuc2F2ZXJseS5jb20k';

// Component to handle scroll restoration
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Public Layout Component
function PublicLayout({ children }) {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <PublicHeader />
      <main className="flex-grow pt-24">
        {children}
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <ClerkProvider publishableKey={CLERK_PUBLISHABLE_KEY}>
      <Router>
        <ScrollToTop />
        
        <Routes>
          {/* Marketing Routes Only - Public */}
          <Route path="/" element={
            <PublicLayout>
              <LandingPage />
            </PublicLayout>
          } />
        <Route path="/features" element={
          <PublicLayout>
            <FeaturesPage />
          </PublicLayout>
        } />
        <Route path="/how-it-works" element={
          <PublicLayout>
            <HowItWorksPage />
          </PublicLayout>
        } />
        <Route path="/pricing" element={
          <PublicLayout>
            <PricingPage />
          </PublicLayout>
        } />
        <Route path="/checkout" element={
          <PublicLayout>
            <CheckoutPage />
          </PublicLayout>
        } />
        <Route path="/manage-account" element={
          <PublicLayout>
            <ManageAccountPage />
          </PublicLayout>
        } />
        <Route path="/download" element={
          <PublicLayout>
            <DownloadPage />
          </PublicLayout>
        } />
        <Route path="/privacy-policy" element={
          <PublicLayout>
            <PrivacyPolicyPage />
          </PublicLayout>
        } />
        <Route path="/terms-of-use" element={
          <PublicLayout>
            <TermsOfUsePage />
          </PublicLayout>
        } />
        <Route path="/contact" element={
          <PublicLayout>
            <ContactPage />
          </PublicLayout>
        } />
        <Route path="/alexa/oauth" element={
          <PublicLayout>
            <AlexaOAuthPage />
          </PublicLayout>
        } />
        <Route path="/app" element={<AppRedirectPage />} />
        <Route path="/p/:campaignCode" element={<PromoRedirectPage />} />
        <Route path="/accept-invitation" element={<AcceptInvitationPage />} />
        <Route path="/join" element={<JoinOrganizationPage />} />
      </Routes>
    </Router>
    </ClerkProvider>
  );
}

export default App; 